import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';
import i18n from '@/common/i18n';
import { store } from '@/common/root';
import type { TaskMap } from '@/common/store/modules/tasks/tasksNotificationMapper';

function getNodeName({ nodes }) {
  const node = store.getters['locations/getNodeById'](nodes[0]);
  return node?.name;
}

const taskMap: TaskMap = {
  [TaskName.HA_CREATING]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('HA configuration created'),
      message: i18n.t('HA configuration successfully created')
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Creating the HA configuration')
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error creating HA configuration'),
      message: error,
    })
  },
  [TaskName.HA_ADDING_NODE]: {
    [TaskState.SUCCESS]: ({ payload }) => ({
      title: i18n.t('Node added to HA configuration successfully'),
      message: i18n.tc('Node "{node}" successfully added to HA configuration|{count} nodes successfully added to HA configuration',
        payload.nodes.length,
        {
          node: getNodeName(payload),
          count: payload.nodes.length
        }
      )
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Adding node to HA configuration...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error adding node to HA configuration'),
      message: error,
    })
  },
  [TaskName.HA_DELETING]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('HA configuration destroyed'),
      message: i18n.t('HA configuration successfully destroyed'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Destroying HA configuration...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error destroying HA configuration'),
      message: error,
    })
  },
  [TaskName.HA_REMOVING_NODE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Node removed from HA configuration'),
      message: i18n.t('Node successfully removed from HA configuration'),
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Removing node from HA configuration...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error removing node from HA configuration'),
      message: error,
    })
  },
  [TaskName.HA_RECONFIGURING]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('High availability for compute cluster reconfigured'),
      message: i18n.t('High availability for the compute cluster successfully reconfigured')
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Reconfiguring high availability for compute cluster...'),
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error reconfiguring high availability for compute cluster'),
      message: error,
    })
  },
  [TaskName.HA_REPLACING_NODE]: {
    [TaskState.SUCCESS]: ({ payload }) => ({
      message: i18n.t('HA configuration successfully changed', [getNodeName({ nodes: payload.node_to_remove })])
    }),
    [TaskState.RUNNING]: ({ payload }) => ({
      message: i18n.t('Changing HA configuration...', [getNodeName({ nodes: payload.node_to_remove })])
    }),
    [TaskState.FAILED]: ({ error, payload }) => ({
      title: i18n.t('Failed to change HA configuration', [getNodeName({ nodes: payload.node_to_remove })]),
      message: error
    })
  },
};

export default taskMap;
